export const initDivLightboxFirstScreen = () => {
	const element = document.querySelector(`div.lightbox.first-screen`);
	
	if (element) {
		Array.from(element.querySelectorAll(`input[name="city"]`)).forEach((el) => el.addEventListener(`change`, () => {
			location.hash = ``;
			element.querySelector(`button[type="submit"]`).click();
		}));
	}
};
